import { render, staticRenderFns } from "./RulesSettting.vue?vue&type=template&id=42497231&scoped=true"
import script from "./RulesSettting.vue?vue&type=script&lang=js"
export * from "./RulesSettting.vue?vue&type=script&lang=js"
import style0 from "./RulesSettting.vue?vue&type=style&index=0&id=42497231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42497231",
  null
  
)

export default component.exports